import { render, staticRenderFns } from "./ChatJin10Dialog.vue?vue&type=template&id=767490ae"
import script from "./ChatJin10Dialog.vue?vue&type=script&lang=js"
export * from "./ChatJin10Dialog.vue?vue&type=script&lang=js"
import style0 from "./ChatJin10Dialog.vue?vue&type=style&index=0&id=767490ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports